import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    Input
  } from '@angular/core';
import { GUID_EMPTY } from '@core';
import { STColumn } from '@delon/abc/st';
import { ACLService } from '@delon/acl';
import { _HttpClient } from '@delon/theme';
import { finalize } from 'rxjs';
import { DateFormatService } from 'src/app/shared/services/date-format.service';
  
  @Component({
    selector: 'app-stk-posting-modal',
    templateUrl: './stk-posting-modal.component.html',
    styleUrls: ['./stk-posting-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
  })
  export class StkPostingModalComponent implements OnInit {
    @Input() url: string = '';
    @Input() docId: string = '';
    @Input() docType: string = '';
    @Input() documentStatus: number = 2;

    visible = false;
    loading = false;
    list: any[] = [];

    columns: STColumn[];

    constructor(
      private http: _HttpClient,
      private cdr: ChangeDetectorRef,
      private acl: ACLService,
      private dateFormatService: DateFormatService
    ) {
      this.columns = [
        {
          index: 'docDate',
          title: 'Date',
          type: 'date',
          dateFormat: this.dateFormatService.currentDateFormatValue,
          width: '110px'
        },
        { index: 'stockCode', title: 'Stock #', width: '120px' },
        { index: 'stockName', title: 'Stock Name', width: '120px' },
        { index: 'description', title: 'Description' },
        {
          index: 'locationCode',
          title: 'Location',
          acl: { ability: ['m1.8', 'm1.64'], mode: 'allOf' }
        },
        { index: 'referenceNo', title: 'Reference No.', width: '120px' },
        {
          index: 'in',
          title: 'In',
          width: '120px',
          type: 'currency',
          renderTitle: 'amountTitleTpl',
          render: 'inTpl'
        },
        {
          index: 'out',
          title: 'Out',
          width: '120px',
          type: 'currency',
          renderTitle: 'amountTitleTpl',
          render: 'outTpl'
        },
        {
          index: 'amount',
          title: 'Amount',
          width: '120px',
          type: 'currency',
          renderTitle: 'amountTitleTpl',
          render: 'amountTpl'
        }
      ];
    }

    get hideUnitCost() {
      if (this.docType)
        return this.acl.can({ ability: [this.docType + '.hideUnitCost'] });
      return false;
    }

    ngOnInit(): void {
      this.columns = this.columns.filter(
        col => !col.acl || this.acl.canAbility(col.acl)
      );
    }

    get isEmptyId() {
      return !this.docId || this.docId === '0' || this.docId === GUID_EMPTY;
    }

    show() {
      this.list = [];
      this.visible = true;
      this.loading = true;
      this.http
        .get(this.url, { key: this.docId })
        .pipe(
          finalize(() => {
            this.loading = false;
            this.cdr.detectChanges();
          })
        )
        .subscribe(res => {
          this.list = [...res];
        });
    }

    hide() {
      this.visible = false;
    }
  }
  